<template>
    <div :id="popupId" :class="onModalClass">
        <button v-if="isModal" class="close-btn" aria-label="상세보기 화면 닫기" @click="doCloseWeb"></button>
        <div class="popup-conts">
            <iframe :src="url" frameborder="0" width="100%" height="800px"></iframe>
        </div>
    </div>
</template>

<script setup>
    defineOptions({
        name: 'WebDetailView',
    });

    import { onMounted, ref } from 'vue';
    import { useRootStore } from '@/stores/modules';

    const rootStore = useRootStore();
    const emit = defineEmits(['close']);

    const url = ref('');
    const onModalClass = ref('');
    const popupId = ref('popup-1');
    const isModal = ref(false);

    // 웹 모달 닫기
    const doCloseWeb = () => {
        isModal.value = false;
        // 바깥부분 Scroll처리
        document.body.classList.remove('no-scroll');
        // Navi영역 보이기
        rootStore.setNaviVisible(true);

        onModalClass.value = 'popup-wrap slideDown';
        setTimeout(() => {
            onModalClass.value = '';
            emit('close');
        }, 300);
    };
    // 웹정보 상세
    const getWebDetail = (linkUrl, gbn) => {
        url.value = linkUrl;

        if (gbn !== 'MODAL') {
            isModal.value = false;
            // 팝업 CSS의 형태
            onModalClass.value = 'popup-wrap';
            popupId.value = 'popup-page';

            // 페이지이동인 경우 브라우저 뒤로가기버튼 제어
            localStorage.setItem('gotoPage', 'Y');
        } else {
            isModal.value = true;
            // 팝업 CSS의 형태
            onModalClass.value = 'popup-wrap slideUp';

            // Navi영역 감추기
            rootStore.setNaviVisible(false);
        }
    };

    onMounted(() => {
        // 웹페이지상세(페이지이동)
        const { linkUrl } = window.history?.state || false;

        // 웹페이지상세(페이지팝업) - 새창
        let sendData = null;
        try {
            sendData = JSON.parse(localStorage.getItem('sendData'));
        } catch (err) {
            console.log(err);
        }

        //  웹페이지 상세
        if (linkUrl) {
            getWebDetail(linkUrl, 'PAGE');

            // 전달되는 인수의 초기화
            localStorage.setItem('sendData', null);

            //  새창의 경우
        } else if (sendData && sendData?.linkUrl) {
            getWebDetail(sendData.linkUrl, 'NEWPOP');

            // 전달되는 인수의 초기화
            localStorage.setItem('sendData', null);
        }
    });

    defineExpose({ getWebDetail });
</script>
